const camelToSnake = (str) => {
    return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`)
}

const capitalize = (value) => {
    if (!value) return ''
    return value.toLowerCase().replace(/(^| )(\w)/g, s => s.toUpperCase())
}

const initial = (value) => {
    if (!value) return ''
    if (value.includes('Republican')) {
        return 'R'
    } else if (value.includes('Democrat')) {
        return 'D'
    } else {
        return value.charAt(0)
    }
}

const partyAbbrev = (value) => {
    if (!value) return ''
    if (value.includes('Republican')) {
        return 'GOP'
    } else if (['Democrat', 'Democratic'].includes(value)) {
        return 'Dem'
    } else {
        return value.charAt(0)
    }
}

const nameOrdering = (name) => {
    if (!name) return ''
    const split = name.split(', ')
    return split[1] + ' ' + split[0]
}

const margin = (v) => {
    if (typeof v === 'undefined') {
        return
    }
    let value = v.toString()
    if (value === '0') {
        value = 'Even'
    } else if (value.includes('-')) {
        value = value.replace('-', '')
        value = 'D+' + value
    } else {
        value = 'R+' + value
    }
    return value
}

export default {
    camelToSnake,
    capitalize,
    initial,
    nameOrdering,
    margin,
    partyAbbrev
}
